import { format } from "date-fns"

interface FormattedTimestamp {
  displayDate: string
  displayMonthAndYear: string
  displayDayAndDate: string
  displayTime: string
}

function timestampFormatter(timestamp: Date): FormattedTimestamp {
  const displayDate = format(timestamp, "eeee d MMMM yyyy")
  const displayMonthAndYear = format(timestamp, "MMMM yyyy")
  const displayDayAndDate = format(timestamp, "eeee do")
  const displayTime = format(timestamp, "h:mmaaa")

  return { displayDate, displayTime, displayMonthAndYear, displayDayAndDate }
}

export default timestampFormatter
